/** Textos de acessibilidade do núcleo (r5 visual): kanban por teclado, busca remota. Mesclado ao namespace `nucleo`. */
export const acessibilidadePt = {
  kanban: {
    papel: 'cartão arrastável',
    instrucoes: 'Enter abre o cartão. Espaço pega o cartão; as setas esquerda e direita escolhem a coluna; Espaço solta e Esc cancela.',
    inicio: 'Pegou o cartão {{titulo}}. Use as setas para escolher a coluna.',
    sobre: 'Cartão {{titulo}} sobre a coluna {{coluna}}.',
    solto: 'Cartão {{titulo}} solto na coluna {{coluna}}.',
    soltoFora: 'Cartão {{titulo}} solto fora de uma coluna e devolvido ao lugar.',
    cancelado: 'Movimento cancelado. Cartão {{titulo}} voltou ao lugar.',
    cartao: 'cartão',
    colunas: 'Colunas do quadro',
    // U13: a coluna também se arrasta, pela alça do cabeçalho (mouse, toque ou teclado).
    colunaPapel: 'coluna arrastável',
    moverColuna: 'Mover a coluna {{coluna}}',
    instrucoesColuna: 'Espaço pega a coluna; as setas esquerda e direita escolhem a posição; Espaço solta e Esc cancela. Alt com seta esquerda ou direita muda a coluna de lugar direto.',
    colunaInicio: 'Pegou a coluna {{coluna}}. Use as setas para escolher a posição.',
    colunaSobre: 'Coluna {{coluna}} no lugar da coluna {{destino}}.',
    colunaSolta: 'Coluna {{coluna}} levada para o lugar da coluna {{destino}}.',
    colunaCancelada: 'Movimento cancelado. A coluna {{coluna}} voltou ao lugar.',
  },
  pular: { conteudo: 'Pular para o conteúdo' },
  tema: { escuro: 'Tema escuro', atual: 'Tema atual: {{tema}}. Clique para alternar.' },
  avisos: { regiao: 'Avisos (F8 leva ao aviso mais recente)', fechar: 'Fechar aviso' },
  calendario: { diaInteiro: 'Dia inteiro', eventos_one: '{{count}} evento', eventos_other: '{{count}} eventos', eventosDoDia: 'Eventos de {{data}}', eventosDoHorario: 'Eventos de {{data}}, {{hora}}', criarEm: 'Criar em {{quando}}', mostrarMais: 'Mostrar mais {{n}} (faltam {{total}})' },
  busca: {
    resultados_one: '{{count}} resultado',
    resultados_other: '{{count}} resultados',
  },
};
